<template>
  <div>
    <div class="card-title" style="margin-top: 20px;">
      发票记录
      <template>
        <el-link type="primary" icon="el-icon-refresh" @click="getInvoiceNumberList"/>
        <el-link type="primary" icon="el-icon-plus" style="margin-left: 10px" title="添加发票记录" @click="handleAdd"/>
      </template>
    </div>
    <div v-if="!dataList.length" class="formCard">
      无发票信息
    </div>
    <div v-else class="formCard default-table">
      <el-table :data="dataList" border>
        <!--        <el-table-column label="系统编号" prop="id" align="center" sortable width="80"></el-table-column>-->
        <el-table-column label="发票号码" prop="invoice_number" align="center" width="160" sortable></el-table-column>
        <el-table-column label="来源" prop="source" align="center" width="100" sortable>
          <template slot-scope="{row}">
            <span>{{ sourceFormat(row.source) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="记录人" prop="creator.name" align="center" sortable></el-table-column>
        <el-table-column label="记录时间" prop="created_at" align="center" sortable></el-table-column>
        <el-table-column label="修改时间" prop="updated_at" align="center" sortable></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="{row}">
            <el-link type="danger" icon="el-icon-delete" @click="handleDelete(row)">删除
            </el-link>
          </template>

        </el-table-column>
      </el-table>
    </div>

    <!-- 添加或修改参数配置对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="600px" append-to-body>
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="发票编号" prop="invoice_number">
              <el-input v-model="form.invoice_number" maxlength="20" placeholder="发票号码" show-word-limit clearable/>
            </el-form-item>
          </el-col>

        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {addOrderInvoiceNumber, delOrderInvoiceNumber, getOrderInvoiceNumberList} from "@/api/order";
import {judgeOrderWholeCase} from "@/views/adOrder";

export default {
  name: "InvoiceNumberPanel",
  props: {
    orderId: {
      type: [Number, String],
      default() {
        return null
      }
    },
    isWcmChildOrder: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  data() {
    return {
      judgeOrderWholeCase,
      dataList: [],
      title: '添加发票记录',
      open: false,//弹窗
      form: {invoice_number: null, order_id: null},
      rules: {
        invoice_number: {required: true, message: '发票号码必填'}
      },
      sourceMap: {
        'order': '订单录入',
        'invoice': '申请开票',
      }
    }
  },
  methods: {
    sourceFormat(val) {
      return this.sourceMap[val] ? this.sourceMap[val] : '未知'
    },
    async getInvoiceNumberList() {
      // this.$notify.info('加载发票记录')
      this.dataList = []
      let params = {order_id: this.orderId}

      let {list} = await getOrderInvoiceNumberList(params).then((res) => {
        return res.model;
      })
      this.$nextTick(() => {
        this.dataList = list
      })

    },
    /** 新增按钮操作 */
    handleAdd() {
      this.open = true;
      this.form.order_id = this.orderId;
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs["form"].validate(async valid => {
        if (valid) {
          let {success} = await addOrderInvoiceNumber(this.form);
          if (success) {
            this.$notify.success('添加成功')
            this.open = false;
            this.getInvoiceNumberList()
          }
        }
      });
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {};
      this.resetForm("form");
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      // const ids = row.id || this.ids;
      const id = row.id;
      this.$msgbox.confirm('是否确认删除发票号码为"' + row.invoice_number + '"的数据项?', "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        let {info} = await delOrderInvoiceNumber({id: id}).then(resp => {
          return resp.model;
        });
        if (info)
          await this.getInvoiceNumberList();
        // this.msgSuccess("删除成功");
      }).catch(function () {
      });
    },
  },
  created() {
    this.getInvoiceNumberList()
  }
}
</script>
